import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DocumentoGenerado } from '../tabs/documentos-emitidos/models/response-documento-generado';
import { DocumentosEmitidosService } from '../tabs/documentos-emitidos/documentos-emitidos.service';
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'vista-previa-documento',
    templateUrl: 'vista-previa-documento.component.html',
    imports:[
        CommonModule,
        MatIconModule,
        MatButtonModule,
    ]
})

export class VistaPreviaDocumentoComponent implements OnInit {
    @Input() archivo:DocumentoGenerado
    @Output() closeDrawer = new EventEmitter<void>();
    documentUrl: SafeResourceUrl;
    documentType:string
    documentData:  ArchivosSubidosInterface;
    renderObject:boolean = true;

    constructor(private documentosEmititosService:DocumentosEmitidosService) { }

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['archivo'] && this.archivo) {
            this.documentType = 'application/pdf';
            this.renderObject = false;
            this.obtenerDocumento()
        }
    }

    closeDrawer1() {
        this.closeDrawer.emit();
    }

    obtenerDocumento() {
        this.documentosEmititosService.obtenerDocumentoGenerado(this.archivo.documentoGeneradoUuid)
        .then(response => {
            this.documentUrl = response;
            this.renderObject = true;
        });
    }

}